export interface AdjustmentEquipment {
    item: string
    number: number
    charge: number
}
export interface ObjectToAdjustmentEquipmentProps {
    item: string
    number: number | string
    charge: number | string
}
export const ObjectToAdjustmentEquipment = (obj: ObjectToAdjustmentEquipmentProps): AdjustmentEquipment => {
    return {
        item: obj.item,
        number: typeof obj.number === "string" ? parseInt(obj.number) : obj.number,
        charge: typeof obj.charge === "string" ? parseInt(obj.charge) : obj.charge,
    }
}